import withQuery, { RouteQueryProps } from "./WithQuery";

export {
  RouteQueryProps,
  withQuery,
};
